import {useState} from "react";
import {FirstAidKitState} from "../Model/FirstAidKitState";
import {FirstAidKitData} from "../Model/FirstAidKitData";
import FirstAidKitFactory from "../Factory/FirstAidKitFactory";
import Homepage from "../../Shared/Page/Homepage";
import Button from "../../Shared/Components/Button";
import FirstAidKitPlay from "./FirstAidKitPlay";
import FirstAidKitSummary from "./FirstAidKitSummary";

export default function FirstAidKitContent(props: { title: string, subtitle: string, data: FirstAidKitData }) {

    const [state, setState] = useState<FirstAidKitState>(FirstAidKitFactory.homepage)

    switch (state.screen) {
        case "homepage": return <Homepage
            title={props.title}
            subtitle={props.subtitle}
            buttons={[ <Button
                color={"default"}
                title={"Start"}
                onClick={() => {
                    setState(FirstAidKitFactory.play())
                }}
            />]}
            onCancel={ () => {} }
        />
        case "play": return <FirstAidKitPlay title={props.title} subtitle={props.subtitle} items={props.data.items} onFinish={(score) => { setState(FirstAidKitFactory.summary(score)) }} onCancel={() => { setState(FirstAidKitFactory.homepage()) }} />
        case "summary": return <FirstAidKitSummary title={props.title} subtitle={props.subtitle} items={props.data.items} onFinish={() => {}} onCancel={() => { setState(FirstAidKitFactory.homepage()) }} score={state.score} />
    }
}